import { IFormTemplateState } from '@/store/form-template';
import { IFormTemplateMutations } from './mutations.types';
import {
  IFormFieldData,
  IFormFieldOptionTodoData,
  IFormFieldOptionTodoTemplateData,
  IFormTemplateData
} from '@/models';

export const mutations: IFormTemplateMutations = {
  SET_FORM_TEMPLATES(
    state: IFormTemplateState,
    payload: IFormTemplateData[]
  ): void {
    state.formTemplates = payload;
  },

  ADD_FORM_TEMPLATE(
    state: IFormTemplateState,
    payload: IFormTemplateData
  ): void {
    state.formTemplates.push(payload);
  },

  UPDATE_FORM_TEMPLATE(
    state: IFormTemplateState,
    payload: IFormTemplateData
  ): void {
    const index = state.formTemplates.findIndex(
      (formTemplate: IFormTemplateData) => formTemplate.id === payload.id
    );

    state.formTemplates.splice(index, 1, payload);
  },

  REMOVE_FORM_TEMPLATE(state: IFormTemplateState, payload: number): void {
    const index = state.formTemplates.findIndex(
      (formTemplate: IFormTemplateData) => formTemplate.id === payload
    );

    state.formTemplates.splice(index, 1);
  },

  //fields
  SET_FORM_FIELDS(state: IFormTemplateState, payload: IFormFieldData[]): void {
    state.formFields = payload;
  },
  ADD_FORM_FIELD(state: IFormTemplateState, payload: IFormFieldData): void {
    state.formFields.push(payload);
  },
  UPDATE_FORM_FIELD(state: IFormTemplateState, payload: IFormFieldData): void {
    const index = state.formFields.findIndex(
      (formTemplate: IFormFieldData) => formTemplate.id === payload.id
    );

    state.formFields.splice(index, 1, payload);
  },
  REMOVE_FORM_FIELD(state: IFormTemplateState, payload: number): void {
    const index = state.formFields.findIndex(
      (formTemplate: IFormFieldData) => formTemplate.id === payload
    );

    state.formFields.splice(index, 1);
  },

  //TODO
  SET_FORM_FIELD_OPTION_TODOS(
    state: IFormTemplateState,
    payload: IFormFieldOptionTodoData[]
  ): void {
    state.formFieldOptionTodos = payload;
  },
  ADD_FORM_FIELD_OPTION_TODO(
    state: IFormTemplateState,
    payload: IFormFieldOptionTodoData
  ): void {
    state.formFieldOptionTodos.push(payload);
  },
  UPDATE_FORM_FIELD_OPTION_TODO(
    state: IFormTemplateState,
    payload: IFormFieldOptionTodoData
  ): void {
    const index = state.formFieldOptionTodos.findIndex(
      (formTemplate: IFormFieldOptionTodoData) => formTemplate.id === payload.id
    );

    state.formFieldOptionTodos.splice(index, 1, payload);
  },
  REMOVE_FORM_FIELD_OPTION_TODO(
    state: IFormTemplateState,
    payload: number
  ): void {
    const index = state.formFieldOptionTodos.findIndex(
      (formTemplate: IFormFieldOptionTodoData) => formTemplate.id === payload
    );

    state.formFieldOptionTodos.splice(index, 1);
  },

  //todo-templates
  SET_FORM_TODO_TEMPLATES(
    state: IFormTemplateState,
    payload: IFormFieldOptionTodoTemplateData[]
  ): void {
    state.formTodoTempates = payload;
  },

  ADD_FORM_TODO_TEMPLATE(
    state: IFormTemplateState,
    payload: IFormFieldOptionTodoTemplateData
  ): void {
    state.formTodoTempates.push(payload);
  },

  UPDATE_FORM_TODO_TEMPLATE(
    state: IFormTemplateState,
    payload: IFormFieldOptionTodoTemplateData
  ): void {
    const index = state.formTodoTempates.findIndex(
      (formTodo: IFormFieldOptionTodoTemplateData) => formTodo.id === payload.id
    );

    state.formTodoTempates.splice(index, 1, payload);
  },

  REMOVE_FORM_TODO_TEMPLATE(state: IFormTemplateState, payload: number): void {
    const index = state.formTodoTempates.findIndex(
      (formTodo: IFormFieldOptionTodoTemplateData) => formTodo.id === payload
    );

    state.formTodoTempates.splice(index, 1);
  }
};
